export default (values) => {
  const errors = {};

  if (!values?.name) errors.name = true;
  if (!values?.duration) errors.duration = true;

  return errors;
};
